import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface GAIASecondaryNavigationStyles {
    wrapper?: InjectableCss;
}

export const secondaryNavStyles: GAIASecondaryNavigationStyles = {
    wrapper: {
        css: css`
            background-color: #f3efeb;
            display: flex;
            width: 100%;
            > div[class^="Wrapper"] {
                > div[class^="GridWrapper"] {
                    margin: 0 auto;
                }
            }
            > div:first-child {
                flex-grow: 1;
                .main-nav-container {
                    flex-wrap: wrap;
                    padding-left: 0px;
                    a[class^="StyledButton"] {
                        padding: 0.5rem;
                    }
                }
            }
            > div:last-child {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: auto;
                max-width: 500px;
                padding: 0.25rem 0rem;
                > div[class^="sc"] {
                    a {
                        cursor: pointer;
                        p {
                            color: ${getColor("text.link")};
                            font-weight: bold;
                        }
                    }
                }
            }
        `,
    },
};

const styles = secondaryNavStyles;

const GAIASecondaryNavigation: FC<Props> = ({ id }) => {
    return (
        <Hidden below="lg">
            <StyledWrapper {...styles.wrapper}>
                <Zone contentId={id} zoneName="SecondaryNavigationLeft" />
                <Zone contentId={id} zoneName="SecondaryNavigationRight" />
            </StyledWrapper>
        </Hidden>
    );
};

const secondaryNavigation: WidgetModule = {
    component: GAIASecondaryNavigation,
    definition: {
        group: "Common",
        displayName: "GAIA Secondary Navigation",
        icon: "link-simple",
    },
};

export default secondaryNavigation;
